import {store} from './store'
import ConversationModel from '/app/src/model/Conversation/model'
import UserModel from '/app/src/model/User/model'
import CustomerModel from '/app/src/model/Customer/model'
import CompanyModel from '/app/src/model/Company/model'
import EmployeeModel from '/app/src/model/Employee/model'
import NotificationModel from '/app/src/model/Notification/model';
import UserSelector from '/app/src/model/User/selector'
import { toast } from 'react-toastify';
import {fromJS } from 'immutable'
import {notify} from '/app/src/lib/WebNotification/notification';
var socket = null;
var isSocketConnected = false;

const NEW_MESSAGE_PATH = '/audio/new-message.mp3'

function notifyUser(title, sender, body, type) {
    //NOTE: The title parameter is reset in the Dashboard component with a listener
    const state = store.getState();
    if (!document.hasFocus() && !UserSelector.mutedTypes(state).has(type)) {
        if (UserSelector.webNotifyIsOn(state))
            notify(title, sender, body);

        if (UserSelector.soundNotifyIsOn(state)) {
            var audio = new Audio(NEW_MESSAGE_PATH);
            audio.play();
        }
        document.title = '* Jibber Dashboard'
        var favicon = document.querySelector('link[rel="shortcut icon"]');
        if(favicon){
            favicon.setAttribute('type', 'image/png');
            favicon.setAttribute('href', '/favicon_notice.ico');
        }
    }
}



export function listen(userId, token) {
    if (!socket){
        console.log('ERROR: NO SOCKET TO LISTEN');
        return;
    }

    let companyId = 'whatever';
    socket.on('connected', () => {
        socket.emit('authenticate', companyId, token, 'employee');
    });
    socket.on('disconnect', (reason) => {
        if (reason === 'io server disconnect') {
            // the disconnection was initiated by the server, you need to reconnect manually
            socket.connect();
        }
        // else the socket will automatically try to reconnect
    });

    socket.on('reconnect', (attemptNumber) => {
        console.log('try to reconnect');
        store.dispatch(UserModel.getInitialData(true))
  // ...
    });
    socket.on('read', (data) => {
        store.dispatch(ConversationModel.setParticipantRead(data.room, data.participant_id))
    });
    socket.on('new_entry', (data) => {
        var {do_not_disturb, room , entry} = data
        do_not_disturb = do_not_disturb?do_not_disturb:[]

        const entryCreatorId = entry.creator_id;
        const reduxState = store.getState();
        const userId = reduxState.getIn(['user', 'login', 'id']);

        if (entryCreatorId !== userId) {
            var name = null;
            const employees = reduxState.getIn(['employee', 'items']);
            const customers = reduxState.getIn(['customer', 'items']);
            const entryCreatorIdString = entryCreatorId.toString();
            if (employees.has(entryCreatorId))
                name = employees.getIn([entryCreatorId, 'display_name']);
            else if (customers.getIn([entryCreatorIdString, 'info', 'payload', 'name']) != null)
                name = customers.getIn([entryCreatorIdString, 'info', 'payload', 'name']);
            else
                name = 'Kund #' + customers.getIn([entryCreatorIdString, 'info', 'payload', 'company_customer_id']);

            if (entry.meta === false || ['online_formular', 'offline_message'].includes(entry.meta.type)) {
                if(!do_not_disturb.includes(userId))
                    notifyUser('new_entry', name, entry.entry_body)
            };
        }

        //const typing = reduxState.get('typing');

        if (entryCreatorId === userId) {
            store.dispatch(ConversationModel.setEntryToConfirmed(room, entry))
        } else{
            store.dispatch(ConversationModel.addConfirmedEntry(room, entry))
        }

    });

    socket.on('user_online', (data) => {
        switch(data.user_type){
            case 'employee':
                store.dispatch(EmployeeModel.isOnline(data.user_id))
                break;
            case 'customer':
            default:
                store.dispatch(CustomerModel.isOnline(data.user_id));
                store.dispatch(CompanyModel.statsLiveUpdateNbr('nbr_online_customers',1))
        }
    });

    socket.on('customer_live_info_server', (payload) => {
        let customer_id = payload.customer_id
        let data = payload.data
        if('url' in data){
            store.dispatch(CustomerModel.updateInfo(customer_id, 'current_url', data.url));
        }
    });

    socket.on('user_offline', (data) => {
        switch(data.user_type){
            case 'employee':
                store.dispatch(EmployeeModel.isOffline(data.user_id))
                break;
            case 'customer':
            default:
                store.dispatch(CustomerModel.isOffline(data.user_id))
                store.dispatch(CompanyModel.statsLiveUpdateNbr('nbr_online_customers', -1))
        }
    });

    socket.on('notification', (notification) => {
        // TODO
        //store.dispatch(actionAddNotification(notification));
        var type = '';

        const reduxState = store.getState();
        const token = reduxState.getIn(['user', 'login', 'token']);

        if (notification.content) {
            type = notification.content.type;
        } else {
            type = notification.type;
        }
        let room = null;
        switch (type) {
            case 'ticket_transferred':
                room = notification.content.ticket_room
                store.dispatch(NotificationModel.addNotification(notification));
                const toId= notification.content.details.to_id;
                const isAssignedUser = UserSelector.getId(reduxState) === toId

                if (isAssignedUser) {
                    store.dispatch(ConversationModel.readFromDB(room));
                    store.dispatch(ConversationModel.readEntries(room));
                    store.dispatch(ConversationModel.setType(room, 'assigned'));

                    const customerDisplayName = notification.content.details.customer.name ?
                        `"${notification.content.details.customer.name}"`
                        :'#'+notification.content.details.customer.company_customer_id ;

                    socket.emit('join_conversation', room, token, 'employee');
                    toast.info(
                        `Besökaren ${customerDisplayName} överfördes till dig från ${notification.content.details.from_name}.`
                    );
                }
                break;
            case 'ticket_resolved':
                // this already handle below
                break;
            case 'billing_change':
                //store.dispatch(NotificationModel.addNotification(notification));
                break;
            default:
                console.log('==== socket event not handle ====');
                console.log(notification);
        }

    });

    socket.on('new_ticket', (data) => {
        store.dispatch(ConversationModel.setType(data.room, 'unassigned'));
        store.dispatch(ConversationModel.setInfo(data.room, data.ticket));
        store.dispatch(ConversationModel.readEntries(data.room));
        store.dispatch(CustomerModel.readFromRawConversation(data.ticket));
        store.dispatch(CompanyModel.statsTicketCreatedAdd(data.ticket.date_created, 1))
    });
    socket.on('entry', payload => {
        switch(payload.type){
            case 'update':
                store.dispatch(ConversationModel.updateEntry(payload.meta.room, payload.data.entry))
                break;
            default:
                console.log(payload);
        }
    })
    socket.on('customer', payload=> {
        switch(payload.type){
            case 'update':
                store.dispatch(CustomerModel.setInfo(payload.data.customer.id, payload.data.customer))
                break;
            default:
                console.log(payload);
        }
    })
    socket.on('stats', payload=> {
        switch(payload.type){
            case 'live':
                store.dispatch(CompanyModel.statsLiveUpdate('nbr_online_customers', payload.stats))
                break;
            default:
                console.log(payload);
        }
    })

    socket.on('new_intern_conversation', (conversation) => {
        const reduxState = store.getState();
        const token = reduxState.get('token');
        socket.emit('join_conversation', conversation.room, token, 'employee');
    });

    socket.on('ticket', data=>{
        switch(data.type){
            case 'resolved':
                store.dispatch(CompanyModel.statsLiveUpdateNbr('nbr_active_tickets', -1))
                break;
            case 'assigned':
                store.dispatch(CompanyModel.statsLiveUpdateNbr('nbr_active_tickets', 1))
                store.dispatch(CompanyModel.statsResponseTimeAdd(data.response.time, data.response.second))
                if(data.employee_id !== userId){
                    const customerDisplayName = data.customer.name ?
                        `"${data.customer.name}"`
                        :'Besökare #'+data.customer.company_customer_id ;
                    toast.info(
                        `${customerDisplayName} har tagits emot av ${data.employee_name}.`
                    )

                    store.dispatch(ConversationModel.setType(data.room, 'ticket_assigned_taken'))
                    store.dispatch(ConversationModel.setMetaInfo(data.room, 'Ärendet hanterades av '+data.employee_name))
                    store.dispatch(ConversationModel.addConfirmedEntry(data.room,
                        fromJS({
                            creator_id: data.employee_id,
                            date_created: '2018-10-18 13:20:55.374082',
                            entry_body: 'Ärendet hanterades av '+data.employee_name,
                            has_file: false,
                            id: 3009,
                            meta: false
                        })
                    ))
                    socket.emit('leave_conversation', data.room, token, 'employee');
                }else{
                    store.dispatch(ConversationModel.removeEntries(data.room))
                    store.dispatch(ConversationModel.readEntries(data.room))
                    store.dispatch(ConversationModel.setType(data.room, 'assigned'))
                    socket.emit('join_conversation', data.room, token, 'employee');
                }
                break;
            default:
                return;
        }

    })

    socket.on('user_writing_server', (data) => {
        store.dispatch(ConversationModel.isTyping(data.room))
    });

    socket.on('logout', (data) => {
        store.dispatch(UserModel.logout())
    });
}

export function getSocket() {
    return socket;
};

export function createSocket(url) {
    if (!isSocketConnected && url) {
        socket = require('socket.io-client')(url);
        window.io = socket;
        isSocketConnected = true;
    }
};
export function destroySocket() {
    if (isSocketConnected) {
        socket.removeAllListeners('connected');
        socket.removeAllListeners('new_entry');
        socket.removeAllListeners('user_online');
        socket.removeAllListeners('user_offline');
        socket.removeAllListeners('notification');
        socket.removeAllListeners('new_ticket');
        socket.removeAllListeners('new_intern_conversation');
        socket.removeAllListeners('user_writing_server');
        socket.removeAllListeners('logout');
        socket.disconnect();
        socket = null;
        delete window.io;
        isSocketConnected = false;
    }

};



// WEBPACK FOOTER //
// ./src/store/socket.js